import React from 'react';
import { Segmented } from 'antd';
import { AppstoreOutlined, UnorderedListOutlined } from '@ant-design/icons';

export type JobApplicationViewMode = 'table' | 'board';

export const JOB_APPLICATIONS_VIEW_STATE_KEY = 'jobApplicationsViewMode';

export function isJobApplicationViewMode(
  value: unknown
): value is JobApplicationViewMode {
  return value === 'table' || value === 'board';
}

export function readJobApplicationsViewMode(
  state: unknown
): JobApplicationViewMode | undefined {
  if (!state || typeof state !== 'object') {
    return undefined;
  }
  const mode = (state as Record<string, unknown>)[JOB_APPLICATIONS_VIEW_STATE_KEY];
  return isJobApplicationViewMode(mode) ? mode : undefined;
}

interface Props {
  value: JobApplicationViewMode;
  onChange: (mode: JobApplicationViewMode) => void;
  boardDisabled?: boolean;
}

const JobApplicationViewToggle: React.FC<Props> = ({
  value,
  onChange,
  boardDisabled = false,
}) => (
  <Segmented
    value={value}
    onChange={(next) => onChange(next as JobApplicationViewMode)}
    options={[
      {
        label: 'Table',
        value: 'table',
        icon: <UnorderedListOutlined />,
      },
      {
        label: 'Board',
        value: 'board',
        icon: <AppstoreOutlined />,
        disabled: boardDisabled,
      },
    ]}
  />
);

export default JobApplicationViewToggle;
